import { size } from 'lodash'
import React from 'react'

type TJoin = {
  children: React.ReactNode
  separator: React.ReactElement
}

// TODO: dumb and breaks easily
const Join = (props: TJoin): React.ReactElement => {
  const { children = [], separator } = props

  const clearedChildren = (children as any).filter(Boolean)

  if (size(clearedChildren) < 1) {
    return clearedChildren
  }
  return clearedChildren.reduce(
    (
      result: React.ReactElement[],
      child: React.ReactElement,
      index: number,
    ) => {
      const newChild = React.cloneElement(child, { key: index, index })
      if (index < clearedChildren.length - 1) {
        return result.concat([
          newChild,
          React.cloneElement(separator, { key: `${index}-separator` }),
        ])
      }
      return result.concat(newChild)
    },
    [],
  )
}

export default Join
